<template>
    <form v-on:keyup.13="updateOffice">
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label class="label" v-text="$t('name_label')"></label>
                    <p class="control has-icon has-icons-right">
                        <input
                            v-validate="'required'"
                            :class="{'input': true, 'is-danger': errors.has(`editOffice.name`) }"
                            v-model="editOffice.name"
                            :name="`editOffice.name`"
                            type="name">
                        <span v-show="errors.has('editOffice.name')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-8">
                <div class="field">
                    <label class="label" v-text="$t('street_name_label')"></label>
                    <p class="control has-icon has-icons-right">
                        <input
                            v-validate="'required'"
                            :class="{'input': true, 'is-danger': errors.has(`editOffice.streetName`) }"
                            v-model="editOffice.streetName"
                            :name="`editOffice.streetName`"
                            type="streetName">
                        <span v-show="errors.has('editOffice.streetName')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                    </p>
                </div>
            </div>
            <div class="column is-4">
                <div class="field">
                    <label class="label" v-text="$t('street_number_label')"></label>
                    <p class="control has-icon has-icons-right">
                        <input
                            v-validate="'required'"
                            :class="{'input': true, 'is-danger': errors.has(`editOffice.streetNumber`) }"
                            v-model="editOffice.streetNumber"
                            :name="`editOffice.streetNumber`"
                            type="streetNumber">
                        <span v-show="errors.has('editOffice.streetNumber')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-4">
                <div class="field">
                    <label class="label" v-text="$t('zip_code_label')"></label>
                    <p class="control has-icon has-icons-right">
                        <input
                            v-validate="'required'"
                            :class="{'input': true, 'is-danger': errors.has(`editOffice.zipCode`) }"
                            v-model="editOffice.zipCode"
                            :name="`editOffice.zipCode`"
                            type="zipCode">
                        <span v-show="errors.has('editOffice.zipCode')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                    </p>
                </div>
            </div>
            <div class="column is-8">
                <div class="field">
                    <label class="label" v-text="$t('locality_label')"></label>
                    <p class="control has-icon has-icons-right">
                        <input
                            v-validate="'required'"
                            :class="{'input': true, 'is-danger': errors.has(`editOffice.locality`) }"
                            v-model="editOffice.locality"
                            :name="`editOffice.locality`"
                            type="locality">
                        <span v-show="errors.has('editOffice.locality')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label class="label" v-text="$t('country_label')"></label>
                    <p class="control has-icon has-icons-right">
                        <div :class="{'select is-fullwidth': true, 'is-danger': errors.has(`editOffice.countryId`) }">
                            <select
                                class="is-block"
                                v-model="editOffice.countryId"
                                :name="`editOffice.countryId`"
                                v-validate="'required'"
                                :disabled="Object.keys(countries).length == 1">
                                <option v-bind:value="null">{{ $t('select_country_label') }}</option>
                                <option v-for="(country, id) in countries" v-text="$t(`Countries_${countr.code}`)" v-bind:value="id"></option>
                            </select>
                        </div>
                        <span v-show="errors.has('editOffice.country')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label class="label" v-text="$t('phone_label')"></label>
                    <p class="control has-icon has-icons-right">
                        <input
                            v-validate="{
                                required: true,
                                regex: getPhoneRegex()
                            }"
                            :class="{'input': true, 'is-danger': errors.has(`editOffice.phone`) }"
                            v-model="editOffice.phone"
                            :name="`editOffice.phone`"
                            :placeholder="getCurrentCountryPhonePrefix() + '...'"
                            type="phone">
                        <span v-show="errors.has('editOffice.phone')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                    </p>
                    <span v-show="errors.has('editOffice.phone')" class="help is-danger">{{ $t('phone_error', { prefix: getCurrentCountryPhonePrefix() }) }}</span>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label class="checkbox">
                        <input
                            type="checkbox"
                            v-model="editOffice.isEmergencyEmailAlertEnabled">
                            <span v-html="$t('emergency_alert_label')"></span>
                    </label>
                </div>
            </div>
        </div>
        <button @click.prevent="updateOffice" class="button is-primary mt-3">
            <b-icon icon="check-circle"></b-icon>
            <span>{{ $t('update_button_label') }}</span>
        </button>
        <button @click.prevent="confirmDeleteOffice" class="button is-danger is-outlined is-pulled-right mt-3">
            <b-icon icon="delete-forever"></b-icon>
            <span>{{ $t('delete_button_label') }}</span>
        </button>
    </form>
</template>

<script>
import axios from 'axios'
import helpers from '@/mixins/helpers'
import firebase from 'firebase/app'
import { store } from '@/store'

import doctorOfficeRepository from '@/data/DoctorOfficeRepository'

const GEOCODE_BASE_URL = 'https://maps.googleapis.com/maps/api/geocode/json'

export default {
    name: 'profile-office',

    mixins: [helpers],

    data () {
        return {
            editOffice: {}
        }
    },

    mounted () {
        this.fetchOffice()
    },

    methods: {
        getPhoneRegex () {
            return '^(\\' + this.getCurrentCountryPhonePrefix() + '[0-9]{8,10})$'
        },

        fetchOffice () {
            this.editOffice = Object.assign({}, this.offices[this.$route.params.id])
            this.$validator.reset()

            this.$emit('positionChanged', {
                name: 'office',
                location: this.editOffice.location
            })
        },

        geocode (onSuccess, onError) {
            axios.get(GEOCODE_BASE_URL, {
                params: {
                    address: this.getFullAddress(),
                    key: process.env.GEOCODING_API_KEY
                }
            })
            .then(({data}) => {
                this.editOffice.location = new firebase.firestore.GeoPoint(data.results[0].geometry.location.lat, data.results[0].geometry.location.lng)

                this.$emit('positionChanged', {
                    name: 'office',
                    location: this.editOffice.location
                })

                onSuccess()
            })
            .catch(onError)
        },

        getCurrentCountryName () {
            return this.$t('Countries.' + (this.countries[this.editOffice.countryId] ? this.countries[this.editOffice.countryId].code : 'default'))
        },

        getCurrentCountryPhonePrefix() {
            return this.countries[this.editOffice.countryId] ? this.countries[this.editOffice.countryId].phonePrefix : ''
        },

        getFullAddress () {
            return `${this.editOffice.streetNumber} ${this.editOffice.streetName},${this.editOffice.zipCode} ${this.editOffice.locality} ${this.getCurrentCountryName()}`
        },

        updateOffice () {
            if (this.isLoading) {
                return false
            }

            this.setLoading(true)

            this.$validator.validateAll().then((result) => {
                if (! result) {
                    this.setLoading(false)

                    this.alertError(this.$t('fields_are_missing'))

                    return false
                }

                this.editOffice.name = this.editOffice.name.trim()
                this.editOffice.name = this.editOffice.name.charAt(0).toUpperCase() + this.editOffice.name.slice(1)
                this.editOffice.streetName = this.editOffice.streetName.trim()
                this.editOffice.streetName = this.editOffice.streetName.charAt(0).toUpperCase() + this.editOffice.streetName.slice(1)
                this.editOffice.locality = this.editOffice.locality.trim()
                this.editOffice.locality = this.editOffice.locality.charAt(0).toUpperCase() + this.editOffice.locality.slice(1)

                this.geocode(() => {

                    if (!this.editOffice.location || (this.editOffice.location.lat == process.env.DEFAULT_LAT && this.editOffice.location.lng == process.env.DEFAULT_LNG)) {
                        this.setLoading(false)

                        this.alertWarning(this.$t('DoctorProfile.geocoding_no_results_found'))

                        return false
                    }

                    doctorOfficeRepository.update(this.doctor.id, this.editOffice.id, this.editOffice, () => {

                        this.alertSuccess(this.$t('office_alert_update_successful'))

                        this.fetchOffice()

                        this.setLoading(false)
                    }, (error) => {
                        this.alertError(error.message)

                        this.setLoading(false)
                    })

                }, (error) => {
                    this.setLoading(false)

                    this.alertWarning(error.message)
                })
            })
        },


        confirmDeleteOffice () {
            this.$dialog.confirm({
                title: this.$t('delete_dialog_title'),
                message: this.$t('delete_dialog_message'),
                type: 'is-danger',
                hasIcon: 'true',
                cancelText: this.$t('cancel_button_label'),
                confirmText: this.$t('ok_button_label')
            })
        }
    },

    watch: {
        '$route' (to, from) {
            this.fetchOffice()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Doctor/ProfileOffice.vue